import { Router, ActivatedRoute, Params } from '@angular/router';

import { HttpErrorHandler } from './http-error-handler';

export class List {
  path: string;
  pages = 0;
  pageSize = 50;
  currentPage = 1;
  pagesRangeWithDots: any[] = [];
  collection: any[] = [];
  defaultFilterParams = '';
  params: any = {};
  filterParams = '';
  orderParam = '';

  service: any = null;
  modelHandler: any;
  listRouter: Router;
  activeRoute: ActivatedRoute;
  protected httpErrorHandler: HttpErrorHandler;

  constructor(service, modelHandler, router, route) {
    this.service = service;
    this.modelHandler = modelHandler;
    this.listRouter = router;
    this.activeRoute = route;
  }

  initList(path, filter) {
    const parent = this;
    const promise = new Promise(function (resolve) {
      parent.path = path;

      parent.activeRoute.params.subscribe((params: Params) => {
        parent.params = {};

        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            parent.params[key] = params[key];
          }
        }

        if (filter != null) {
          parent.filterParams = filter.serializeQueryParams(parent.params);
          parent.filterParams = parent.defaultFilterParams + '&' + parent.filterParams;
        }

        if (parent.params['o']) {
          parent.orderParam = parent.params['o'];
        }

        if (isNaN(parent.params['page'])) {
          parent.currentPage = 1;
        } else {
          parent.currentPage = Number.parseInt(parent.params['page']);
        }

        parent.list(parent.currentPage).then((result) => {
          resolve(result);
        });
      });
    });

    return promise;
  }

  goToPage(page) {
    this.params['page'] = page;
    const path = '/'.concat(this.path);
    this.listRouter.navigate([path, this.params]);
  }

  calculate_pagination(response: any) {
    this.pagesRangeWithDots = [];
    this.pages = Math.ceil(response.count / this.pageSize);
    const delta = 2;
    const range = [];
    let l = 0;

    const leftIndex = this.currentPage - delta;
    const rightIndex = this.currentPage + delta;

    for (let i = 1; i <= this.pages; i++) {
      if (i === 1 || i === this.pages || (i >= leftIndex && i < rightIndex)) {
        range.push(i);
      }
    }

    for (const i of range) {
      if (l) {
        if (i - l === 2) {
          this.pagesRangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          this.pagesRangeWithDots.push('...');
        }
      }
      this.pagesRangeWithDots.push(i);
      l = i;
    }

    return this.pagesRangeWithDots;
  }

  parseResults(response) {
    this.calculate_pagination(response);
    const objects = [];
    for (const key in response.results) {
      if (response.results.hasOwnProperty(key)) {
        objects.push(this.modelHandler.apiMap(response.results[key]));
      }
    }

    return objects;
  }

  list(page): any {
    const parent = this;
    const promise = new Promise(function (resolve) {
      parent.currentPage = page;
      parent.service.list(page, parent.pageSize, parent.filterParams, parent.orderParam).subscribe(
        (response) => {
          parent.collection = parent.parseResults(response);
          parent.listCallback();
          resolve(parent.collection);
        },
        (error) => parent.httpErrorHandler.handleHttpError(error)
      );
    });

    return promise;
  }

  listCallback() {}

  applyOrdering(param) {
    this.params['o'] = param;
    const path = '/'.concat(this.path);
    this.listRouter.navigate([path, this.params]);
  }

  exportToExcel() {
    this.service.exportToExcel().subscribe(
      (response) => {
        this.service.downloadExcel(response.token, this.filterParams, this.orderParam);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/list.ts